import type { KeyboardEvent, MouseEvent } from 'react';

/**
 * True when the browser's own link handling should win over an in-app click
 * handler: a modifier click opens the href in a new tab or window (or starts a
 * download), and a non-primary button is not a plain activation.
 *
 * Any handler that hijacks an anchor for SPA navigation has to bail out on
 * these before calling `preventDefault`, otherwise the anchor stops behaving
 * like a link and "open in new tab" silently navigates the current one instead.
 *
 * Accepts a keyboard activation as well as a pointer one, because ADS menu
 * items invoke their `onClick` for both. `button` is only meaningful for a
 * pointer event and is `undefined` on a keyboard one, so testing it
 * unconditionally would report every Enter and Space as modified and make the
 * handler bail out of its own navigation.
 */
export const isModifiedClick = (event: MouseEvent<Element> | KeyboardEvent<Element>): boolean =>
	('button' in event && event.button !== 0) ||
	event.metaKey ||
	event.ctrlKey ||
	event.shiftKey ||
	event.altKey;
